import { render, staticRenderFns } from "./Lgx297738824396570624.vue?vue&type=template&id=6c025518&scoped=true&"
import script from "./Lgx297738824396570624.vue?vue&type=script&lang=js&"
export * from "./Lgx297738824396570624.vue?vue&type=script&lang=js&"
import style0 from "./Lgx297738824396570624.vue?vue&type=style&index=0&id=6c025518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c025518",
  null
  
)

export default component.exports